<template>
  <div>
    <v-row class="ma-0">
      <v-btn small
        >問{{ !$route.params.id ? Number(no) + 1 : Number(no) }}</v-btn
      >
    </v-row>
    <v-row class="mx-0 mt-2 lead-sentence">
      <span class>{{ formGeneral.leadSentence }}</span>
    </v-row>
    <v-row
      class="mx-0"
      v-for="(rowName, idx) in formGeneral.name"
      :key="`preview-${idx}`"
      :class="{ 'mt-5': idx == 0 }"
      :justify="
        formGeneral.name.length == 1 && (!rowName[0] || !rowName[2])
          ? 'center'
          : null
      "
    >
      <span
        class="text--h4 font-weight-bold pre-wrap"
        v-if="rowName[1] || rowName[1] == ''"
        v-html="`${replaceText(rowName[0])}`"
      />
      <span
        class="text--h4 font-weight-bold pre-wrap"
        v-if="rowName[1] || rowName[1] == ''"
        v-html="
          `（&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）${replaceText(rowName[1])}`
        "
      />
    </v-row>
    <v-row class="mx-0 mt-5">
      <v-col
        :cols="!checkLength ? 6 : 12"
        v-for="(answers, index) in formGeneral.answers"
        :key="index"
      >
        <button class="width-10 pa-1 grey lighten-4 button-template">
          {{ answers.value ? answers.value : answers.name }}
        </button>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: ["no"],
  store: ["formGeneral"],
  data() {
    return {};
  },
  computed: {
    checkLength() {
      return Boolean(this.formGeneral.answers.find((e) => e.value.length > 9));
    },
  },
  methods: {
    replaceText(name) {
      return name
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
  },
};
</script>
<style scoped>
.lead-sentence {
  white-space: pre-wrap;
  padding-bottom: 8px;
  border-bottom: 5px dotted #feb798;
}
button {
  word-wrap: break-word;
}
</style>